import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, PriorityBadge, Avatar, scoreColor } from "@/components/common/ui";

export default function Residents() {
  const navigate = useNavigate();
  const [residents, setResidents] = useState(null);
  const [programs, setPrograms] = useState([]);
  const [q, setQ] = useState("");
  const [prog, setProg] = useState("");

  useEffect(() => {
    api.get("/residents").then((r) => setResidents(r.data)).catch(() => setResidents([]));
    api.get("/programs").then((r) => setPrograms(r.data)).catch(() => {});
  }, []);

  if (!residents) return <div className="flex h-64 items-center justify-center text-muted-foreground"><Loader2 className="animate-spin" /></div>;

  const filtered = residents.filter((r) =>
    (`${r.first_name} ${r.last_name}`).toLowerCase().includes(q.toLowerCase()) &&
    (!prog || r.program_id === prog));

  return (
    <div>
      <PageHeader overline="Care · Master Records" title="Residents"
        description="Unified resident profiles with health, medications, activities, incidents and risk intelligence." />

      <div className="mb-4 flex flex-wrap items-center gap-3">
        <div className="relative flex-1 min-w-[220px]">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input data-testid="resident-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search residents…"
            className="h-10 w-full rounded-md border bg-card pl-9 pr-3 text-sm outline-none focus:border-[#155EEF]" />
        </div>
        <select data-testid="resident-program-filter" value={prog} onChange={(e) => setProg(e.target.value)}
          className="h-10 rounded-md border bg-card px-3 text-sm outline-none focus:border-[#155EEF]">
          <option value="">All programs</option>
          {programs.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
        </select>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {filtered.map((r, i) => (
          <button key={r.id} data-testid={`resident-card-${r.id}`} onClick={() => navigate(`/residents/${r.id}`)}
            className="careiq-rise group flex items-center gap-3 rounded-xl border bg-card p-4 text-left shadow-sm transition-colors hover:border-[#155EEF]"
            style={{ animationDelay: `${i * 30}ms` }}>
            <Avatar name={`${r.first_name} ${r.last_name}`} seed={r.avatar_seed || i} size={44} />
            <div className="min-w-0 flex-1">
              <div className="truncate font-semibold">{r.first_name} {r.last_name}</div>
              <div className="truncate text-xs text-muted-foreground">{r.program_name} · Room {r.room}</div>
              <div className="mt-1.5"><PriorityBadge level={r.risk_level} /></div>
            </div>
            <div className="text-right">
              <div className="text-lg font-bold" style={{ color: scoreColor(100 - r.risk_score) }}>{r.risk_score}</div>
              <div className="overline">risk</div>
            </div>
            <ChevronRight size={16} className="text-muted-foreground" />
          </button>
        ))}
      </div>
    </div>
  );
}
